module.exports = __webpack_public_path__ + "img/graph.7b772941.svg";